// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button() {
  const disabledStyle = {
    "&.Mui-disabled": {
      // backgroundColor: theme.palette.grey[200]
      background: "#0000001f",
      color: "#828282",
      pointerEvents: "inherit",
      cursor: "not-allowed",
    },
  };

  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: 400,
        },
        contained: {
          ...disabledStyle,
        },
        outlined: {
          ...disabledStyle,
        },
      },
    },
  };
}
